// PhaseItem Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'
import { DragSource as dragSource, DropTarget as dropTarget } from 'react-dnd'
import classnames from 'classnames'

import { WithDragSource as ActivityItem } from '../activity_item/activity_item.jsx'
import ActionAdd from '../action_add/action_add.jsx'
import PhaseInfo from '../phase_info/phase_info.jsx'
import PopupBudgetStatus from '../../../../project/popup/popup_budget_status/popup_budget_status.jsx'

const itemSource = {
  beginDrag (props, _monitor) {
    const {
      phase,
      showOptions,
      showExpand,
      activeFilters,
      canEdit,
      projectCloseDate,
      rateCards,
      columnOptions
    } = props

    phase.orgIndex = phase.id

    return {
      dragItemType: 'phase',
      phase,
      showOptions,
      showExpand,
      columnOptions,
      activeFilters,
      canEdit,
      projectCloseDate,
      rateCards
    }
  },
  endDrag (props, monitor) {
    const { phase, dragItemType } = monitor.getItem()
    const didDrop = monitor.didDrop()
    const currentIndex = phase.id

    if (dragItemType === 'phase') {
      if (!didDrop) {
        if (props.onMovePhase) {
          props.onMovePhase(phase, currentIndex, phase.orgIndex)
        }
      } else {
        if (props.onDropItem) {
          props.onDropItem()
        }
      }
    }
  }
}

const itemTarget = {
  drop (props, monitor) {
    const { item, dragItemType } = monitor.getItem()

    if (dragItemType === 'activity' && props.phase && props.onDropItem) {
      if (item.type !== 'pagebreak' || props.phase.items.length > 1) {
        if (props.phase.id !== item.phaseId) {
          props.onMoveItem(item.phaseId, props.phase.id, null, item, null)
        }

        props.onDropItem()
      } else {
        // Revert to original position, if pagebreak not placed in between items
        props.onMoveItem(
          item.phaseId,
          item.orgPhaseId,
          null,
          item,
          item.orgIndex
        )
      }
    }
  },
  hover (props, monitor, component) {
    const { phase, dragItemType } = monitor.getItem()

    if (dragItemType === 'phase') {
      const overId = props.phase.id
      const currentIndex = phase.id
      const overIndex = overId

      const boundingRect = ReactDOM.findDOMNode(
        component
      ).getBoundingClientRect()
      const clientOffset = monitor.getClientOffset()
      const ownMiddleY = boundingRect.bottom - boundingRect.top
      const offsetY = clientOffset.y - boundingRect.top

      if (currentIndex < overIndex && offsetY < ownMiddleY - 80) {
        return
      }

      if (currentIndex > overIndex && offsetY > 80) {
        return
      }

      if (
        dragItemType === 'phase' &&
        props.onMovePhase &&
        phase.id !== overId
      ) {
        props.onMovePhase(phase, currentIndex, overIndex)
      }
    }
  }
}

class PhaseItem extends Component {
  constructor (props) {
    super(props)

    this._references = {
      phaseStatus: React.createRef()
    }
  }

  static get propTypes () {
    return {
      canEdit: PropTypes.bool,
      showOptions: PropTypes.bool,
      showExpand: PropTypes.bool,
      phase: PropTypes.object,
      columnOptions: PropTypes.array,
      onChangeActivity: PropTypes.func,
      onSaveActivity: PropTypes.func,
      onKeyDownActivity: PropTypes.func,
      onDeleteActivity: PropTypes.func,
      onEditActivity: PropTypes.func,
      onChangePhase: PropTypes.func,
      onSavePhase: PropTypes.func,
      onKeyDownPhase: PropTypes.func,
      onDeletePhase: PropTypes.func,
      onToggleExpand: PropTypes.func,
      onClickEditActivity: PropTypes.func,
      onCopyPhase: PropTypes.func,
      onClickEditPhase: PropTypes.func,
      onSelectRatecard: PropTypes.func,
      onAddActivity: PropTypes.func,
      onChangePhaseStatus: PropTypes.func,
      onMoveItem: PropTypes.func,
      projectCloseDate: PropTypes.object,
      rateCards: PropTypes.array,
      dragItem: PropTypes.object,
      getItemPosition: PropTypes.func,
      activeFilters: PropTypes.object,
      showItems: PropTypes.bool,
      connectDragSource: PropTypes.func,
      connectDragPreview: PropTypes.func,
      connectDropTarget: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      canEdit: false,
      showOptions: false,
      showExpand: false,
      phase: null,
      columnOptions: [],
      onChangeActivity: null,
      onSaveActivity: null,
      onKeyDownActivity: null,
      onDeleteActivity: null,
      onEditActivity: null,
      onChangePhase: null,
      onSavePhase: null,
      onKeyDownPhase: null,
      onDeletePhase: null,
      onToggleExpand: null,
      onClickEditActivity: null,
      onCopyPhase: null,
      onClickEditPhase: null,
      onSelectRatecard: null,
      onAddActivity: null,
      onChangePhaseStatus: null,
      onMoveItem: null,
      projectCloseDate: null,
      rateCards: null,
      dragItem: null,
      getItemPosition: null,
      activeFilters: null,
      showItems: false,
      connectDragSource: null,
      connectDragPreview: null,
      connectDropTarget: null
    }
  }

  render () {
    const {
      phase,
      showExpand,
      activeFilters,
      onChangeActivity,
      onSaveActivity,
      onKeyDownActivity,
      onDeleteActivity,
      onEditActivity,
      onChangePhase,
      onSavePhase,
      onKeyDownPhase,
      onDeletePhase,
      onToggleExpand,
      onClickEditActivity,
      canEdit,
      onClickEditPhase,
      projectCloseDate,
      rateCards,
      onSelectRatecard,
      getItemPosition,
      onMoveItem,
      showItems,
      dragItem,
      columnOptions
    } = this.props
    const canEditPhase =
      canEdit && ['estimate', 'active'].indexOf(phase.status) >= 0
    const connectDragSource =
      this.props.connectDragSource || this._defaultDragRender
    const connectDragPreview =
      this.props.connectDragPreview || this._defaultDragRender
    const connectDropTarget =
      this.props.connectDropTarget || this._defaultDragRender

    return connectDragPreview(
      connectDropTarget(
        <div
          className={classnames('phase-item', {
            isdragging:
              dragItem && dragItem.phase && dragItem.phase.id === phase.id,
            disabled: canEditPhase
          })}
        >
          <PhaseInfo
            phase={phase}
            activeFilters={activeFilters}
            showExpand={showExpand}
            canEdit={canEditPhase}
            onChange={onChangePhase}
            onSave={onSavePhase}
            onKeyDown={onKeyDownPhase}
            onDelete={onDeletePhase}
            onToggleExpand={onToggleExpand}
            onClickEdit={onClickEditPhase}
            onClickStatus={this._onClickPhaseStatus} // eslint-disable-line react/jsx-handler-names
            onCopyPhase={this._onCopyPhase} // eslint-disable-line react/jsx-handler-names
            connectDragSource={connectDragSource}
            columnOptions={columnOptions}
          />
          {(phase.isExpand || !showExpand) && showItems && (
            <div className='phase-item-activities'>
              {phase &&
                phase.items.map((item, itemIdx) => {
                  let bShowItem = activeFilters.length === 0
                  if (!bShowItem) {
                    if (item.type === 'time-activity') {
                      bShowItem = activeFilters.indexOf('time') >= 0
                    } else if (item.type === 'expense-activity') {
                      bShowItem = activeFilters.indexOf('expense') >= 0
                    }
                  }

                  if (!bShowItem) {
                    return null
                  }

                  return (
                    <ActivityItem
                      key={`${item.id}-${itemIdx}`}
                      item={item}
                      activeFilters={activeFilters}
                      canEdit={canEditPhase}
                      rateCards={rateCards}
                      itemAsString={JSON.stringify(item)}
                      onChange={onChangeActivity}
                      onSave={onSaveActivity}
                      onKeyDown={onKeyDownActivity}
                      onDelete={onDeleteActivity}
                      onEdit={onEditActivity}
                      onClickEdit={onClickEditActivity}
                      onAddActivity={this._onAddActivity} // eslint-disable-line react/jsx-handler-names
                      onSelectRatecard={onSelectRatecard}
                      getItemPosition={getItemPosition}
                      onMoveItem={onMoveItem}
                      columnOptions={columnOptions}
                    />
                  )
                })}
            </div>
          )}
          {canEditPhase && phase.isExpand && (
            <ActionAdd
              activeFilters={activeFilters}
              onAddActivity={this._onAddActivity.bind(this, null)}
            />
          )}
          <PopupBudgetStatus
            ref={this._references.phaseStatus}
            status={phase.status}
            container={this}
            closeDate={projectCloseDate}
            onChange={this._onChangePhaseStatus} // eslint-disable-line react/jsx-handler-names
          />
        </div>
      )
    )
  }

  _onAddActivity = (item, type) => {
    const { onAddActivity, phase } = this.props
    if (onAddActivity) {
      onAddActivity(phase.id, item, type)
    }
  }

  _onClickPhaseStatus = () => {
    if (this._references.phaseStatus.current) {
      this._references.phaseStatus.current.show()
    }
  }

  _onChangePhaseStatus = obj => {
    const { onChangePhaseStatus, phase } = this.props

    if (this._references.phaseStatus.current) {
      this._references.phaseStatus.current.hide()
    }

    if (onChangePhaseStatus) {
      onChangePhaseStatus(phase.id, obj)
    }
  }

  _onCopyPhase = () => {
    const { onCopyPhase, phase } = this.props

    if (onCopyPhase) {
      onCopyPhase(phase.id)
    }
  }

  _defaultDragRender (node) {
    return node
  }
}

function arePropsEqual (_nextProps, _props) {
  return false
}

const options = { arePropsEqual }

const WithDragSource = dropTarget(
  _props => 'all',
  itemTarget,
  (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  }),
  options
)(
  dragSource(
    _props => 'all',
    itemSource,
    (connect, monitor) => ({
      connectDragSource: connect.dragSource(),
      connectDragPreview: connect.dragPreview(),
      isDragging: monitor.isDragging(),
      dragItem: monitor.getItem()
    }),
    options
  )(PhaseItem)
)

export { WithDragSource }

export default PhaseItem
